import React from 'react'

const IconsDesktopMobile = (props) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='icons-icon'
            {...props}
        >
            <path
                d='M11.9997 5.33317V3.99984C11.9997 3.64622 11.8592 3.30708 11.6092 3.05703C11.3591 2.80698 11.02 2.6665 10.6663 2.6665H2.66634C2.31272 2.6665 1.97358 2.80698 1.72353 3.05703C1.47348 3.30708 1.33301 3.64622 1.33301 3.99984V8.6665C1.33301 9.02013 1.47348 9.35926 1.72353 9.60931C1.97358 9.85936 2.31272 9.99984 2.66634 9.99984H7.99967'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.66699 12.6669V10.0269V12.1269'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.66699 12.6665H8.00033'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.3337 8H12.0003C11.2639 8 10.667 8.59695 10.667 9.33333V13.3333C10.667 14.0697 11.2639 14.6667 12.0003 14.6667H13.3337C14.07 14.6667 14.667 14.0697 14.667 13.3333V9.33333C14.667 8.59695 14.07 8 13.3337 8Z'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default IconsDesktopMobile
